var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.21 12.622-.588.59 5.121 5.12.59-.588zM7.917 2.5a5.424 5.424 0 0 1 5.416 5.417 5.424 5.424 0 0 1-5.416 5.416A5.424 5.424 0 0 1 2.5 7.917 5.424 5.424 0 0 1 7.917 2.5m0-.833a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5"
  })));
};
export default SvgSearch;